"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkSkeleton = exports.getSkeleton = exports.getSkinnedMesh = void 0;
var realms_three_1 = __importDefault(require("realms-three"));
/*
 * Gets the skinned mesh inside an object
 */
function getSkinnedMesh(obj) {
    var queue = [obj];
    while (queue.length !== 0) {
        var nextElem = queue.shift();
        if (nextElem instanceof realms_three_1.default.SkinnedMesh) {
            return nextElem;
        }
        queue.push.apply(queue, nextElem.children);
    }
    return null;
}
exports.getSkinnedMesh = getSkinnedMesh;
/*
 * Finds the skeleton in an object
 */
function getSkeleton(obj) {
    var _a, _b;
    return (_b = (_a = getSkinnedMesh(obj)) === null || _a === void 0 ? void 0 : _a.skeleton) !== null && _b !== void 0 ? _b : null;
}
exports.getSkeleton = getSkeleton;
/*
 * Adds a reference to the skeleton for all children objects
 */
function linkSkeleton(obj) {
    var skeleton = getSkeleton(obj);
    if (skeleton === null) {
        throw new Error("Object has not skeleton to link");
    }
    var stack = [obj];
    while (stack.length !== 0) {
        var next = stack.pop();
        if (!(next["skeleton"] instanceof realms_three_1.default.Skeleton)) {
            next["skeleton"] = skeleton;
        }
        stack.push.apply(stack, next.children);
    }
    return obj;
}
exports.linkSkeleton = linkSkeleton;
